<template>
  <div
    class="tabs-wrapper section-space--pt_60 section-space--pb_60 bg-gradient"
    style="padding-top:10px"
    id="service"
  >
    <div class="container">
      <div class="row mt-5">
        <div class="col-lg-12">
          <div class="section-title-wrapper text-center section-space--mb_60">
            <h2
              class="section-title font-weight--blod wow move-up"
              style="color:white;"
            >
              Our SaaS for private Doctors and Clinics
            </h2>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-lg-3">
          <slick class="slick1 tab-slider-nav" :options="slickOptions">
            <div
              class="tab-slider-nav--list wow move-up mt-0"
              style="margin-top:-10px"
            >
              <i class="ht-slider-tab-icon fal fa-chart-pie"></i>
              <h5>Home Dashboard</h5>
              <p>
                Operation statistics and activities.
              </p>
            </div>
            <div
              class="tab-slider-nav--list wow move-up mt-0"
              style="margin-top:-10px"
            >
              <i class="ht-slider-tab-icon fal fa-calendar"></i>
              <h5>Medical Appointment</h5>
              <p>
                Appointments with doctors or patients.
              </p>
            </div>
            <div
              class="tab-slider-nav--list wow move-up mt-0"
              style="margin-top:-10px"
            >
              <i class="ht-slider-tab-icon fal fa-file"></i>
              <h5>Electronic Record</h5>
              <p>
                Medical summaries for every episodes.
              </p>
            </div>
          </slick>
        </div>
        <div class="col-lg-9">
          <slick class="slick2" :options="slickOptions2">
            <div class="pro-large-img img-zoom wow move-up">
              <img class="img-fluid" alt="product-details" src="/b1.png" />
            </div>
            <div class="pro-large-img img-zoom wow move-up">
              <img class="img-fluid" alt="product-details" src="/b2.png" />
            </div>
            <div class="pro-large-img img-zoom wow move-up">
              <img class="img-fluid" alt="product-details" src="/b3.png" />
            </div>
          </slick>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";

export default {
  components: {
    Slick,
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: 3,
        focusOnSelect: true,
        vertical: true,
        asNavFor: ".slick2",
      },
      slickOptions2: {
        arrows: false,
        fade: true,
        dots: true,
        asNavFor: ".slick1",
      },
    };
  },
};
</script>
